<template>
    <div>
        <form @submit.prevent="onSubmit"
              @keydown="form.errors.clear($event.target.name)">
            <div class="modal-form-block">
                <label for="cod_articolo">Codice Articolo:</label>
                <input type="text"
                       id="cod_articolo"
                       name="cod_articolo"
                       class="form-control"
                       placeholder="Codice Articolo Panthera"
                       v-model="form.harp.cod_articolo"
                >
                <span class="alert alert-danger text-aitems-500"
                      v-if="form.errors.has('cod_articolo')"
                      v-text="form.errors.get('cod_articolo')"
                >
                    </span>
            </div>

            <div class="modal-form-block">
                <label for="nome">Nome:</label>
                <input type="text"
                       name="nome"
                       id="nome"
                       class="form-control"
                       placeholder="Nome dell'Arpa"
                       v-model="form.harp.nome"
                >
                <span class="alert alert-danger"
                      v-if="form.errors.has('nome')"
                      v-text="form.errors.get('nome')"
                >
                    </span>
            </div>

            <div class="modal-form-block">
                <label for="descrizione">Descrizione:</label>
                <input type="text"
                       name="descrizione"
                       id="descrizione"
                       class="form-control"
                       placeholder="Descrizione dell'Arpa"
                       v-model="form.harp.descrizione"
                >
                <span class="alert alert-danger"
                      v-if="form.errors.has('descrizione')"
                      v-text="form.errors.get('descrizione')"
                >
                    </span>
            </div>

            <div class="modal-form-block">
                <label for="brand">
                   Marchio:
                </label>
                <div class="relative w-full">
                    <select name="brand" id="brand"
                            v-model="form.harp.brand_id"
                    >
                        <option :value="brand.id"
                                v-for="brand in form.brands"
                                v-text="brand.descrizione"
                        >
                        </option>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                </div>
            </div>
            <div class="modal-form-block">
                <label for="brand">
                    Gruppo:
                </label>
                <div class="relative w-full">
                    <select name="harp_group"
                            id="harp_group"
                            v-model="form.harp.harp_group_id"
                    >
                        <option :value="harp_group.id"
                                v-for="harp_group in form.harp_groups"
                                v-text="harp_group.descrizione"
                        >
                        </option>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                </div>
            </div>
            <div class="modal-form-block mb-6">
                <label for="product_line">
                    Linea Prodotto:
                </label>
                <div class="relative w-full">
                    <select name="product_line"
                            id="product_line"
                            v-model="form.harp.product_line_id"
                            class="form-control"
                    >
                        <option :value="product_line.id"
                                v-for="product_line in form.product_lines"
                                v-text="product_line.descrizione"
                        >
                        </option>
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                    </div>
                </div>
            </div>


            <div class="modal-form-block mb-6">
                <button type="submit"
                        class="w-1/3 mx-auto btn is-aitems-700"
                        :disabled="form.errors.any()"
                >
                    Crea
                </button>
            </div>
        </form>
    </div>

</template>

<script>
    export default {

        data() {
            return {
                form: new Form({
                    harp: {
                        cod_articolo: '',
                        nome: '',
                        descrizione: '',
                        descrizione_estesa: '',
                        brand_id: '',
                        harp_group_id: '',
                        product_line_id: ''
                    },
                    brands: '',
                    harp_groups: '',
                    product_lines: '',
                }),
            }
        },

        created() {
            this.fillTheCombos();
        },

        methods: {
            onSubmit() {
                axios.post('/harps', this.form.harp)
                    .then(response => {
                        swal.fire('Grande!!', 'Arpa Creata :)', 'success');
                        this.fillTheCombos();
                        this.$emit('harp-has-been-created', response.data);
                    })
                    .catch(error => {
                        console.log(error.response.data);
                        this.form.onFail(error.response.data.errors);
                    });
            },

            //Tutta questa funzione adesso è un po' meno brutta :)
            fillTheCombos() {
                this.fill('/brands', 'brands', 'brand_id', 'id');
                this.fill('/harp_groups', 'harp_groups', 'harp_group_id', 'id');
                this.fill('/product_lines', 'product_lines', 'product_line_id', 'id');
            },

            fill(url, field, combo, id) {
                axios.get(url)
                    .then(response => {
                        this.form[field] = response.data;
                        this.form.harp[combo] = this.form[field][0][id];
                    });
            }

        }
    }
</script>